import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PrestartPage } from './prestart';

@NgModule({
  declarations: [
    PrestartPage,
  ],
  imports: [
    IonicPageModule.forChild(PrestartPage),
  ],
})
export class PrestartPageModule {}



// WEBPACK FOOTER //
// ./src/pages/prestart/prestart.module.ts